import { Legend } from '@nokia-csf-uxr/ccfk/FieldSet';
import React from 'react';
import { SingleBandLinkUserContext } from '../../../contexts/SingleBandLinkContext';
import ValueInput from '../../ValueInput';
import Form from 'react-bootstrap/esm/Form';
import Container from 'react-bootstrap/esm/Container';
import WLDInputComponent from '../WLDInputComponent';
import { DualBandLinkUserContext } from '../../../contexts/DualBandLinkContext';

/**
 * Link name component
 */
export default class LinkName extends WLDInputComponent {

    constructor(props: {band: number}) {
        super(props);
    }

    /**
     * Function is called when the path lenght is changed
     * @param link  user's data
     * @param newData New data which has been selected
     */
    onChange(link: Readonly<any>, newData: {index:number, idDistUnit: number}) {
        if(link.distanceUnits.idDistUnit != newData.idDistUnit) {
            link.define("distanceUnits", newData)
            if(newData.idDistUnit == 1) { // Miles to kilometers
                link.define("site_length", link.site_length*1.609)
            } else { // Kilometers to miles
                link.define("site_length", link.site_length/1.609)
            }
        }
    }

    render() {
        return (
            <>
            <Form.Label>Link's name</Form.Label>
                {this.props.band == 1 ? 
                <Container className='mt-2'>
                    <SingleBandLinkUserContext.Consumer>
                    {(link) => (
                        <>
                            <ValueInput valueType="string" value={link?.edit ? link?.link?.name : link?.name}
                                onChange={(data: any) => {
                                    if(link.edit) {
                                        let newdata = link.link;
                                        newdata.name = data;
                                        link.define("link", newdata)
                                    } else {
                                        link.define("name", data)
                                    }
                                }}  
                                onBlur={(data: any, error: any) => {}}></ValueInput>
                        </>
                    )}
                    </SingleBandLinkUserContext.Consumer>
                </Container>
                :
                <>
                    <DualBandLinkUserContext.Consumer>
                    {(link) => (
                        <>
                            <ValueInput valueType="string" value={link.edit ? link?.link?.name : link?.name}
                                onChange={(data: any) => {
                                    if(link.edit) {
                                        let newdata = link.link;
                                        newdata.name = data;
                                        link.define("link", newdata)
                                    } else {
                                        link.define("name", data)
                                    }
                                }}  
                                onBlur={(data: any, error: any) => {}}></ValueInput>
                        </>
                    )}
                    </DualBandLinkUserContext.Consumer>
                </> }
            </>
        );
    }

}
